module.exports = __webpack_public_path__ + "static/2613a064-2962-44af-ae6f-3640e06e8dc4-391b72b88ead53c79abbf555d5a7ba72.woff";